import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M28.393 13.895a129.939 129.939 0 0 0-.403 10.162c-.002 3.375.129 6.724.39 10.048.13 1.647 1.13 2.895 2.321 2.895h2.547C34.215 37 35 35.909 35 34.562V13.439c0-1.347-.784-2.438-1.75-2.438h-2.535c-1.19 0-2.19 1.248-2.32 2.895ZM9.124 11.512l15.232 9.52a3.5 3.5 0 0 1-.002 5.938L9.102 36.489a3 3 0 0 1-4.57-2.212C4.175 31.073 3.998 27.67 4 24.063c.002-3.626.187-7.073.553-10.342a3 3 0 0 1 4.571-2.21Zm34.472 2.383c.267 3.387.401 6.774.403 10.162.002 3.375-.129 6.724-.39 10.048-.13 1.647-1.13 2.895-2.321 2.895H38.74c-.967 0-1.751-1.091-1.751-2.438V13.439c0-1.347.784-2.438 1.75-2.438h2.535c1.19 0 2.19 1.248 2.32 2.895Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPlayPauseFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PlayPauseFilled_default = SvgPlayPauseFilled;

export { PlayPauseFilled_default as default };
